export default "__VITE_ASSET__CEM1kP9p__"